import React from 'react';

import { Typography } from '@/components/_atoms/Typography';

interface Props {
  tyreClass: string;
}

export const ProductTyreClass = (props: Props) => {
  const { tyreClass } = props;

  return (
    <Typography
      variant="body_xxs"
      id="productBox.tyreClass"
      color="grey-standard"
      className="tracking-caption-s"
      values={{
        tyreClass: tyreClass.toUpperCase(),
      }}
    />
  );
};
